// Components
import registerSketch from '../../../../common/drawings/sketches/index';
import presentationalComponent from './Sketch';
import containerComponent from './SketchContainer';
import modalComponent from './modal/LoadableSketchModal';

// Constants
import { TOOLBAR_TOOLS, TOOL_SETS } from '../../../workspace/toolbar/config/toolbarToolConfig';

export default () =>
    registerSketch({
        presentationalComponent,
        containerComponent,
        modalComponent,
        tools: {
            selected: [
                TOOLBAR_TOOLS.COLOR,
                TOOLBAR_TOOLS.LABEL,
                TOOLBAR_TOOLS.REACTION,
                TOOLBAR_TOOLS.COMMENT,
                TOOLBAR_TOOLS.CAPTION,
                ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
                ...TOOL_SETS.TRAILING_SELECTED,
            ],
            editing_CAPTION: TOOL_SETS.TEXT_EDITING_CAPTION,
        },
    });
